import { useMemo } from 'react';
import { OpeningHours } from '../dealer.types';
import { useTranslation } from 'next-i18next';
import { WEEKDAY } from '../utils/dealer-map-utils';

export const useDealerOpeningHours = (openingHours?: OpeningHours, isOpen?: boolean) => {
  const { t } = useTranslation(['shared']);

  const openingHoursForToday: string | null = useMemo(
    () => (openingHours?.[WEEKDAY] ? openingHours?.[WEEKDAY]?.join(`&nbsp;${t('shared_dealers_map_detail_label_and')}&nbsp;`) : null),
    [openingHours, WEEKDAY]
  );

  const openingHoursStatusLabel = useMemo(() => {
    let key: string;

    if (!openingHoursForToday || openingHoursForToday === 'closed') {
      key = 'shared_dealers_map_detail_label_closed_today';
    } else if (isOpen) {
      key = 'shared_dealers_map_detail_label_open_currently';
    } else {
      key = 'shared_dealers_map_detail_label_closed_currently';
    }

    return t(key);
  }, [openingHoursForToday, isOpen, t]);

  const openingHoursCurrentlyOpen = useMemo(() => isOpen && openingHoursForToday?.length, [openingHoursForToday, isOpen]);

  return {
    openingHoursForToday,
    openingHoursStatusLabel,
    openingHoursCurrentlyOpen,
  };
};
